export default "__VITE_ASSET__Bi48_Cvd__"